import { type SearchSummary as SearchSummaryType } from 'Src/types';
import { messages } from '../messages';
import { isSearchRefined } from '../../utils/search-common';

/**
 * Determines the appropriate message descriptor and test ID for search summary
 * @param {Object} searchSummary - The search summary object
 * @param {string|null} locationName - The location name for map-type searches
 * @param {boolean} showSearchDescription - Whether to show search description
 * @returns {Object} Object containing messageDescriptor and testId
 */
export function getSearchSummaryMessage(
  searchSummary: SearchSummaryType,
  locationName: string | null | undefined,
  showSearchDescription: boolean
) {
  const shouldShowRefinedSearch = isSearchRefined(searchSummary);
  const mapTypeSearch = locationName != null;

  if (mapTypeSearch === true) {
    if (showSearchDescription) {
      return {
        messageDescriptor: messages.foundfor,
        testId: 'messages-foundfor'
      };
    }
    return {
      messageDescriptor: messages.found,
      testId: 'messages-found'
    };
  }

  if (showSearchDescription && searchSummary.location != null) {
    return {
      messageDescriptor: messages.foundfornear,
      testId: 'messages-foundfornear'
    };
  } else if (showSearchDescription && shouldShowRefinedSearch) {
    return {
      messageDescriptor: messages.foundForRefined,
      testId: 'messages-foundfor-refined'
    };
  } else if (showSearchDescription) {
    return {
      messageDescriptor: messages.foundfor,
      testId: 'messages-foundfor'
    };
  } else if (searchSummary.location != null) {
    return {
      messageDescriptor: messages.foundnear,
      testId: 'messages-foundnear'
    };
  } else {
    return {
      messageDescriptor: messages.found,
      testId: 'messages-found'
    };
  }
}
